// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addModal .ant-modal-title {
  font-size: 12px !important;
}
.addModal .ant-modal-content {
  padding: 12px 16px 32px;
}
.addModal .form-modal-content {
  margin-top: 35px;
  padding: 0 41px;
}
.addModal .add-form-input {
  width: 240px;
  height: 32px;
  border-radius: 8px;
  opacity: 1;
  font-size: 12px;
  border: none;
  background: #e7edf4;
  transition: none;
}
.addModal .add-form-input ::placeholder {
  color: #999999;
}
.addModal .add-form-input:focus {
  border: 2px solid #0095FC;
  background: #FFFFFF;
}
.addModal .form-modal-select .ant-select-selector {
  background: #E7EDF4;
  border-radius: 8px;
  border: 0;
}
.addModal .ant-modal-footer {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/AddModal/index.module.less"],"names":[],"mappings":"AAAA;EAGM,0BAAA;AADN;AAFA;EAMM,uBAAA;AADN;AALA;EASM,gBAAA;EACA,eAAA;AADN;AATA;EAaM,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AADN;AAnBA;EAsBQ,cAAA;AAAR;AAEM;EACE,yBAAA;EACA,mBAAA;AAAR;AA1BA;EA+BY,mBAAA;EACA,kBAAA;EACA,SAAA;AAFZ;AA/BA;EAqCQ,kBAAA;AAHR","sourcesContent":[":global {\n  .addModal {\n    .ant-modal-title {\n      font-size: 12px !important;\n    }\n    .ant-modal-content {\n      padding: 12px 16px 32px;\n    }\n    .form-modal-content {\n      margin-top: 35px;\n      padding: 0 41px;\n    }\n    .add-form-input {\n      width: 240px;\n      height: 32px;\n      border-radius: 8px;\n      opacity: 1;\n      font-size: 12px;\n      border:none;\n      background: #e7edf4;\n      transition: none;\n      ::placeholder {\n        color: #999999;\n      }\n      &:focus {\n        border: 2px solid #0095FC;\n        background: #FFFFFF;\n      }\n    }\n    .form-modal-select {\n        .ant-select-selector {\n            background: #E7EDF4;\n            border-radius: 8px;\n            border:0;\n        }\n    }\n    .ant-modal-footer {\n        text-align: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
